const getNewsImage = (slug, index) =>
  `https://picsum.photos/seed/${slug}-${index}/1200/800`;

export const newsItems = [
  {
    id: 1,
    date: '15 Jan 2026',
    title: 'Whales Advisory Expands Corporate Practice Team',
    summary:
      'We are pleased to announce the addition of three senior associates to our Corporate Advisory practice, strengthening our capabilities in M&A and capital markets transactions.',
    heroImage: getNewsImage('corporate-practice-team', 1),
    sections: [
      {
        heading: 'Strengthening Our Corporate Advisory Offering',
        paragraphs: [
          'Whales Advisory is delighted to welcome three senior associates to our Corporate Advisory team. Each brings extensive experience in complex M&A transactions, capital markets deals, and corporate restructurings across the region.',
          'The expansion of our team reflects sustained client demand for sophisticated, commercially focused advice on strategic transactions in Egypt and beyond.',
        ],
        image: getNewsImage('corporate-practice-team', 2),
      },
      {
        heading: 'Client-Centred Growth',
        paragraphs: [
          'By investing in senior talent, we aim to further enhance the responsiveness and depth of our services. Our clients will benefit from broader sector coverage and additional bandwidth on time-sensitive mandates.',
          'The new joiners will work closely with partners across our Corporate, Capital Markets, and Disputes practices to deliver integrated solutions on multi-jurisdictional matters.',
        ],
      },
    ],
  },
  {
    id: 2,
    date: '8 Jan 2026',
    title: 'New Office Location in New Cairo',
    summary:
      'Whales Advisory has opened a new office at 29 N Teseen, New Cairo 1, expanding our presence to better serve clients in the greater Cairo area.',
    heroImage: getNewsImage('new-cairo-office', 1),
    sections: [
      {
        heading: 'Expanding Our Footprint',
        paragraphs: [
          'Our new premises in New Cairo are designed to provide a modern, collaborative environment for both our teams and our clients. The location offers convenient access to key business districts and infrastructure.',
          'The office features dedicated client meeting spaces, flexible work areas, and upgraded technology to support in-person and hybrid engagements.',
        ],
        image: getNewsImage('new-cairo-office', 2),
      },
      {
        heading: 'Closer to Our Clients',
        paragraphs: [
          'Establishing a stronger presence in New Cairo allows us to be closer to many of our corporate and financial institution clients. It also positions us well to support new investments and developments in the area.',
          'Our teams across Corporate, Real Estate, Finance, and Disputes will regularly operate from the new location, ensuring continuity and accessibility for our clients.',
        ],
      },
    ],
  },
  {
    id: 3,
    date: '2 Jan 2026',
    title: 'Partnership with International Law Firm',
    summary:
      'We are excited to announce a strategic partnership with a leading international law firm, enabling us to provide enhanced cross-border legal services.',
    heroImage: getNewsImage('international-partnership', 1),
    sections: [
      {
        heading: 'Building a Global Platform',
        paragraphs: [
          'The partnership formalises a long-standing collaboration with a top-tier international law firm that shares our commitment to quality, integrity, and client service.',
          'Together, we will offer seamless cross-border advice on M&A, capital markets, project finance, and disputes, combining deep local knowledge with international reach.',
        ],
        image: getNewsImage('international-partnership', 2),
      },
      {
        heading: 'Benefits for Our Clients',
        paragraphs: [
          'Clients will benefit from integrated teams, unified matter management, and aligned service standards across multiple jurisdictions.',
          'The collaboration will also support knowledge sharing, secondments, and joint training initiatives, strengthening our capabilities across practice areas.',
        ],
      },
    ],
  },
  {
    id: 4,
    date: '28 Dec 2025',
    title: 'Recognition in Legal 500 Middle East',
    summary:
      'Whales Advisory has been recognized in the Legal 500 Middle East rankings for excellence in Corporate and M&A practice areas.',
    heroImage: getNewsImage('legal-500-recognition', 1),
    sections: [
      {
        heading: 'Independent Recognition of Our Work',
        paragraphs: [
          'We are proud to be ranked in the latest edition of Legal 500 Middle East. The recognition reflects feedback from clients, peers, and independent research into the quality of our work.',
          'Our Corporate and M&A teams were highlighted for their commercial approach, responsiveness, and ability to manage complex, high-value transactions.',
        ],
        image: getNewsImage('legal-500-recognition', 2),
      },
      {
        heading: 'Gratitude to Our Clients and Team',
        paragraphs: [
          'We are grateful to our clients for their continued trust and to our colleagues for their dedication and hard work.',
          'This recognition reinforces our commitment to delivering practical, solutions-driven advice that helps clients achieve their strategic objectives.',
        ],
      },
    ],
  },
  {
    id: 5,
    date: '20 Dec 2025',
    title: 'Launch of Digital Platform Services Division',
    summary:
      'We have launched a dedicated Digital Platform Services division to address the growing need for tech-focused legal advisory services.',
    heroImage: getNewsImage('digital-platform-division', 1),
    sections: [
      {
        heading: 'Supporting Digital Transformation',
        paragraphs: [
          'The new division will focus on advising technology companies, digital platforms, and traditional businesses undergoing digital transformation.',
          'Our multidisciplinary team combines expertise in technology, data protection, consumer protection, and financial regulation to provide holistic support.',
        ],
        image: getNewsImage('digital-platform-division', 2),
      },
      {
        heading: 'Services Offered',
        paragraphs: [
          'Key areas of focus include platform terms and policies, regulatory classification, licensing, data governance, and digital consumer journeys.',
          'We also support clients on strategic partnerships, joint ventures, and acquisitions in the technology and digital infrastructure space.',
        ],
      },
    ],
  },
  {
    id: 6,
    date: '12 Dec 2025',
    title: 'Seminar on Egyptian Competition Law',
    summary:
      'Our team conducted a comprehensive seminar on recent developments in Egyptian competition law, attended by over 100 legal professionals.',
    heroImage: getNewsImage('competition-law-seminar', 1),
    sections: [
      {
        heading: 'Engaging with the Legal Community',
        paragraphs: [
          'The seminar covered recent amendments to the competition law framework, enforcement trends, and practical implications for businesses operating in concentrated markets.',
          'Speakers from Whales Advisory and external experts shared insights on merger control, cartels, and abuse of dominance cases handled by the Egyptian Competition Authority.',
        ],
        image: getNewsImage('competition-law-seminar', 2),
      },
      {
        heading: 'Key Takeaways for Businesses',
        paragraphs: [
          'Participants discussed practical steps to strengthen internal compliance programmes, including training, dawn raid preparedness, and review of commercial policies.',
          'We will continue to engage with stakeholders through similar events and thought leadership pieces on competition law and other regulatory topics.',
        ],
      },
    ],
  },
];

export const getNewsById = (id) =>
  newsItems.find((item) => String(item.id) === String(id));

